import { lighten } from "@material-ui/core";
import {
  createMuiTheme,
  darken,
  getContrastRatio,
} from "@material-ui/core/styles";

const primary = "#EA7624";
const contrastThreshold = 3;

export const SolarSchoolsTheme = createMuiTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        margin: 0,

        "& > p": {
          margin: 0,
        },
      },
    },
  },
  palette: {
    primary: {
      dark: darken(primary, 0.2),
      main: primary,
      light: lighten(primary, 0.2),
    },
    secondary: {
      main: "#5E5D63",
    },
    error: {
      main: "#CC1C00",
    },
    text: {
      primary: "#5E5D63",
    },
    contrastThreshold: contrastThreshold,
    getContrastText: (background) => {
      if (!background) {
        throw new TypeError(
          `Material-UI: missing background argument in getContrastText(${background}).`
        );
      }

      if (background === primary) {
        return "#FFFFFF";
      }

      const contrastText =
        getContrastRatio(background, "#FFFFFF") >= contrastThreshold
          ? "#FFFFFF"
          : "rgba(0, 0, 0, 0.87)";

      return contrastText;
    },
  },
  typography: {
    fontFamily: ["Lato", "sans-serif"].join(","),
    fontWeightRegular: 400,
    fontWeightBold: 900,
  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/app/utilities/Theme/theme.js